var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 55,
    viewBox: "0 0 100 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 55,
    rx: 7,
    fill: "#3B5A82"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6614 29.0977H31.7864V26.8633H49.6614V29.0977ZM33.8274 33.8672C33.8274 33.1081 34.0996 32.46 34.6438 31.9229C35.1953 31.3857 35.983 30.9775 37.0071 30.6982C38.0312 30.4189 39.2558 30.2793 40.6809 30.2793C42.0917 30.2793 43.3056 30.4189 44.3225 30.6982C45.3395 30.9704 46.1201 31.3786 46.6643 31.9229C47.2086 32.46 47.4843 33.1081 47.4915 33.8672C47.4843 34.6335 47.2086 35.2852 46.6643 35.8223C46.1201 36.3665 45.3395 36.7783 44.3225 37.0576C43.3056 37.3369 42.0917 37.4766 40.6809 37.4766C39.263 37.4766 38.0384 37.3369 37.0071 37.0576C35.983 36.7783 35.1953 36.3665 34.6438 35.8223C34.0996 35.2852 33.8274 34.6335 33.8274 33.8672ZM33.9563 18.4414H47.513V20.6543H36.6848V23.3184H47.6204V25.4883H33.9563V18.4414ZM36.6204 33.8672C36.6132 34.8841 37.9667 35.3926 40.6809 35.3926C43.3808 35.3926 44.7343 34.8841 44.7415 33.8672C44.7343 33.373 44.387 33.0007 43.6995 32.75C43.012 32.4922 42.0058 32.3633 40.6809 32.3633C39.3274 32.3633 38.3105 32.4922 37.6302 32.75C36.9498 33.0007 36.6132 33.373 36.6204 33.8672ZM68.2351 30.6016H50.3386V28.4102H57.9226V26.9922H52.573V21.6211H63.3152V20.418H52.53V18.291H66.0652V23.5977H55.3015V24.8867H66.4304V26.9922H60.6511V28.4102H68.2351V30.6016ZM52.3366 31.7188H66.1726V37.3906H63.4011V33.8672H52.3366V31.7188Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitBtn);
export default __webpack_public_path__ + "static/media/submitBtn.55351bf9b41dd9176535e8443eda4bc1.svg";
export { ForwardRef as ReactComponent };